import CompareModal from './CompareModal';
export default CompareModal;